module.exports = __webpack_public_path__ + "images/8ba3dc816042268141a2205e3bfc3971.svg";